module.exports = __webpack_public_path__ + "static/media/prtlandingpagepic1.0c2076f2.png";